<template>
  <div class="c-checkbox-list c-checkbox-list__h-line">
    <div class="c-checkbox-list__item" v-for="item in items" :key="item.value">
      <CheckboxListItem :item="item" :key="item.value" v-on:childToParent="change" >
          <template v-slot:CheckboxItemExtraSlot="slotProps">
              <slot name="CheckboxItemExtraSlot"  v-bind:item="slotProps.item " >
              </slot>
          </template>
      </CheckboxListItem>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import CheckboxListItem from './checkbox-list-item.vue';
// @ is an alias to /src
export default Vue.extend({
  name: 'CheckboxList',
  components: {
    CheckboxListItem
  },
  data() {
    return {
      items: this.dataItems ? this.dataItems : [],
      showInfo: false
    };
  },
  props: {
    dataItems: Array
  },
  methods: {
    infoClick(mode) {
      this.showInfo = mode;
    },
    change(e) {
      this.$emit('childToParent', e);
    }
  }
});
</script>
<style lang="scss">
@import '@/assets/scss/essentials/essentials.scss';
$itemHeight: 2.2rem;
$lineHeight: 1.6rem;
$padding: ($itemHeight - $lineHeight) / 2;

@import './checkbox-list';
</style>
